import { useEffect } from "react";
import { ANDROID_PACKAGE, buildSurveyDeepLink, getStoreUrl } from "./constants";

type UseTryOpenMobileAppParams = {
  original_survey_id?: string;
  invitation_id?: string;
};

export function useTryOpenMobileApp(params?: UseTryOpenMobileAppParams) {
  useEffect(() => {
    const ua = navigator.userAgent;
    const isAndroid = /Android/i.test(ua);
    const isIos = /iPhone|iPad|iPod/i.test(ua);

    if (!isAndroid && !isIos) return;
    if (!params?.original_survey_id && !params?.invitation_id) return;

    const deepLink = buildSurveyDeepLink(params);

    if (isAndroid) {
      const fallback = encodeURIComponent(getStoreUrl());
      const path = deepLink.replace("insidebrasil://", "");
      window.location.href =
        `intent://${path}#Intent;scheme=insidebrasil;package=${ANDROID_PACKAGE};` +
        `S.browser_fallback_url=${fallback};end`;
      return;
    }

    window.location.href = deepLink;
  }, [params?.original_survey_id, params?.invitation_id]);
}
